const DESTINATION_CONSENT_STATUS_ERROR = `Failed to determine the consent status for the destination. Please check the destination configuration and try again.`;

export { DESTINATION_CONSENT_STATUS_ERROR };
